import { atom } from "@mongez/react-atom";
import { Project } from "../data/mockData";

export const currentIndexAtom = atom({
  key: "currentIndex",
  default: 0,
});

export const projectsAtom = atom<Project[]>({
  key: "projects",
  default: [],
});
